import * as React from "react";
import { TextInput } from "soprasteria-ui-library";
import { IEmergencyTreatmentReport } from "../../../models/IEmergencyTreatment";
import { IAddress } from "../../../models/IAddress";

interface ITreatingCareProviderSection {
    emergencyTreatmentReport?: IEmergencyTreatmentReport;
}

export const TreatingCareProviderSection: React.FunctionComponent<ITreatingCareProviderSection> = ({ emergencyTreatmentReport }) => {

    const formatAddress = (address: IAddress | undefined): string => {
        if (address?.address === undefined || address?.zipCode === undefined || address?.city === undefined) {
            return "";
        }
        return `${address?.address?.trim()}, ${address.careOf ? "c/o " + address.careOf + ", " : ""} ${address.box ? "box " + address.box + ", " : ""} ${address?.zipCode} ${address?.city}`;
    }

    return (
        <div className="row">
            <div className="col-6">
                <h5>Behandlande tandläkare</h5>
                <TextInput
                    name="carePerformerFullName"
                    label="Namn"
                    defaultValue={emergencyTreatmentReport?.carePerformer?.carePerformerName ?? emergencyTreatmentReport?.dentistName ?? ""}
                    readonly
                    inlineLabel />                
            </div>
            <div className="col-6">
                <h5>Fakturerande vårdgivare</h5>
                <TextInput
                    name="treatingOrganisation"
                    label="Vårdgivare"
                    defaultValue={emergencyTreatmentReport?.treatingCareProvider.displayOrganisationInformation}
                    readonly
                    inlineLabel />
                <TextInput
                    name="treatingCareProvider"
                    label="Mottagning"
                    defaultValue={emergencyTreatmentReport?.treatingCareProvider.displayCareProviderName}
                    readonly
                    inlineLabel />
                <TextInput
                    name="treatingCareProviderAddress"
                    label="Address"
                    defaultValue={formatAddress(emergencyTreatmentReport?.treatingCareProvider.address)}
                    readonly
                    inlineLabel />
            </div>
        </div>
    );
}